export const Null = () => null
